import { render, staticRenderFns } from "./dialog-collect-import.vue?vue&type=template&id=1a3178ea&scoped=true"
import script from "./dialog-collect-import.vue?vue&type=script&lang=js"
export * from "./dialog-collect-import.vue?vue&type=script&lang=js"
import style0 from "./dialog-collect-import.vue?vue&type=style&index=0&id=1a3178ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3178ea",
  null
  
)

export default component.exports